module.exports = __webpack_public_path__ + "img/1534959072.941f1675.jpg";